import { browserFocusReset, cssSpacing } from "../../styles/index.js";
import styled from "../../styled-components.js";
export var Body = styled.div.withConfig({
  displayName: "Body",
  componentId: "sc-19u46fy-0"
})(["", " padding-inline:", ";padding-block-end:", ";overflow:auto;"], browserFocusReset, cssSpacing('looser', '20px'), cssSpacing('base', '16px'));